import { IconSize } from '@icons/types';
import { BorderedInputSizeVariant } from '@primitives/BorderedInput/types';
import { inputSizeToIconSize } from './constants';

export const getSearchIconSize = (size: BorderedInputSizeVariant = 'small'): IconSize => {
    return inputSizeToIconSize[size];
};

export const SampleIcon: React.FC = () => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        cursor={'pointer'}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.3334 0.666504C15.0948 0.666504 17.3334 2.90508 17.3334 5.6665V12.3332C17.3334 15.0946 15.0948 17.3332 12.3334 17.3332H5.66669C2.90526 17.3332 0.666687 15.0946 0.666687 12.3332V5.6665C0.666687 2.90508 2.90526 0.666504 5.66669 0.666504H12.3334ZM11.5 3.1665H6.50002C4.71486 3.1665 3.25745 4.56981 3.17077 6.33347L3.16669 6.49984V11.4998C3.16669 13.285 4.56999 14.7424 6.33365 14.8291L6.50002 14.8332H11.5C13.2852 14.8332 14.7426 13.4299 14.8293 11.6662L14.8334 11.4998V6.49984C14.8334 4.71467 13.43 3.25727 11.6664 3.17058L11.5 3.1665Z"
            fill="#969696"
        />
    </svg>
);
